import apiClient from "./apiClient";
import { Role, RoleListItem, Permission, RoleUser, AssignableUser, AddRoleUsersResult } from "../admin/models";
import { UserRole } from "common/models";


const getUserRoles = async ():Promise<UserRole[]> =>{
  return apiClient.get("/admin/user-roles");
}

const getRoles = async (): Promise<RoleListItem[]> => {
  return apiClient.get("/admin/roles");
};
const getPermissions = async (): Promise<Permission[]> =>{
    return apiClient.get("/admin/permissions");
}
const getRole = async (id: number): Promise<Role> => {
  let uri = `/admin/roles/${id}`;
  return apiClient.get(uri);
};

const addRole = async (name:string): Promise<any> =>{
    return apiClient.post(`/admin/roles`, {name: name});
}
const addRolePermission = async (roleId: number, permissionId: number): Promise<any> =>{
  return apiClient.post(`/admin/roles/${roleId}/permissions/${permissionId}`);
};

const removeRolePermission = async (roleId: number, permissionId:number): Promise<any> =>{
  return apiClient.remove(`/admin/roles/${roleId}/permissions/${permissionId}`);
}

const getRoleUsers = async (roleId: number): Promise<RoleUser[]> => {
  return apiClient.get(`/admin/roles/${roleId}/users`);
};

const searchAssignableUsers = async (roleId: number, query: string, take = 20): Promise<AssignableUser[]> => {
  return apiClient.get(`/admin/roles/${roleId}/assignable-users?query=${encodeURIComponent(query)}&take=${take}`);
};

const addRoleUsers = async (roleId: number, employeeIds: number[]): Promise<AddRoleUsersResult> => {
  return apiClient.post(`/admin/roles/${roleId}/users`, { employeeIds });
};

const removeRoleUser = async (roleId: number, employeeId: number): Promise<any> => {
  return apiClient.remove(`/admin/roles/${roleId}/users/${employeeId}`);
};

const getDispatchQueues = async (active?: boolean): Promise<any[]> => {
  let uri = "/admin/dispatch-queues";
  if (active !== undefined) {
    uri += `?active=${active}`;
  }
  return apiClient.get(uri);
};

const getDispatchQueue = async (id: number): Promise<any> => {
  return apiClient.get(`/admin/dispatch-queues/${id}`);
};

const createDispatchQueue = async (name: string, hubIds: number[]): Promise<any> => {
  return apiClient.post("/admin/dispatch-queues", { name, hubIds });
};

const updateDispatchQueue = async (id: number, name: string, active: boolean): Promise<any> => {
  return apiClient.put(`/admin/dispatch-queues/${id}`, { name, active });
};

const addDispatchQueueHub = async (dispatchQueueId: number, hubId: number): Promise<any> => {
  return apiClient.post(`/admin/dispatch-queues/${dispatchQueueId}/hubs/${hubId}`);
};

const removeDispatchQueueHub = async (dispatchQueueId: number, hubId: number): Promise<any> => {
  return apiClient.remove(`/admin/dispatch-queues/${dispatchQueueId}/hubs/${hubId}`);
};

const adminService = {
  getUserRoles,
  getRoles,
  getPermissions,
  getRole,
  addRole,
  addRolePermission,
  removeRolePermission,
  getRoleUsers,
  searchAssignableUsers,
  addRoleUsers,
  removeRoleUser,
  getDispatchQueues,
  getDispatchQueue,
  createDispatchQueue,
  updateDispatchQueue,
  addDispatchQueueHub,
  removeDispatchQueueHub
};

export default adminService;